import { AddressFormFields } from "@/components/address-form-fields/address-form-fields";
import { addressFormDefaultValues, addressFormSchema } from "@/components/address-form-fields/address-form-schema";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { Button } from "@/components/ui/button";
import { Form } from "@/components/ui/form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation } from "wouter";
import { z } from "zod";
import { useRelocationOrderInitStore } from "@/modules/fit/internal/relocation-order/init/_hooks/use-relocation-order-init-store";

const formSchema = z.object({
  originExternalAddress: addressFormSchema,
});

type FormValues = z.infer<typeof formSchema>;

export function InitSetOriginExternalAddressView() {
  const { t } = useTranslation(["fit"]);
  const [_, navigate] = useLocation();

  const setOriginExternalAddress = useRelocationOrderInitStore((state) => state.setOriginExternalAddress);

  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    mode: "onChange",
    defaultValues: {
      originExternalAddress: addressFormDefaultValues,
    },
  });

  const onSubmit = (values: FormValues) => {
    setOriginExternalAddress(values.originExternalAddress);

    navigate("~/fit/relocation-order/init/select-destination-branch");
  };

  return (
    <CenteredLayout
      variant={CenteredLayoutVariant.Form}
      title={t("fit:SetOriginAddress")}
      subTitle={t("fit:SetOriginAddressDescription")}
    >
      <Form {...form}>
        <form className="flex w-full flex-col gap-6" onSubmit={form.handleSubmit(onSubmit)}>
          <AddressFormFields prefix="originExternalAddress" />

          <div className="flex flex-row justify-end">
            <Button type="submit" disabled={!form.formState.isValid}>
              {t("fit:Next")}
            </Button>
          </div>
        </form>
      </Form>
    </CenteredLayout>
  );
}
